export * from './add-edit-product-price.component';
